// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:


class MobileAppBackButton extends React.Component {
	render() {
		const { location } = this.props
		const pathArray = window.location.pathname.split( '/' )

		let url,
			text

		if ( pathArray[ 2 ] ) {
			switch ( pathArray[ 1 ] ) {
				case 'program':
				case 'programs':
					url = '/programs'
					text = 'Programs'
			}

			switch ( pathArray[ 1 ] ) {
				case 'votd':
					url = '/votd'
					text = 'Verses'
			}
		}

		return (
			<div className="mobile-app-back-button">
				{ url &&
					<Link to={ url }>
						<i className="icon-chevron-left" aria-hidden="true"></i>

						<span>{ text }</span>
					</Link>
				}
			</div>
		)
	}
}

export default MobileAppBackButton
